import { HistoryEventType } from '../../../../../Model/CoachHistory';

const texts = {
  eventText: {
    [HistoryEventType.ACCOUNT_CREATED]: 'Coach to sign up to the system',
    [HistoryEventType.PROFILE_SET]: 'Set up the coach profile',
    [HistoryEventType.STRIPE_CONNECTED]: 'Create and connect the Stripe account',
    [HistoryEventType.LEAD_FORM_CREATED]: 'Create the coach lead form',
    [HistoryEventType.POST_PAYMENT_FORM_LINKED]: 'Create and link the post-payment form',
    [HistoryEventType.FIRST_PRODUCT_CREATED]: 'Create the products for the coach',
    [HistoryEventType.WEBSITE_APPROVED]: 'Website approved by coach',
    [HistoryEventType.APP_LOGO_SET]: 'Set up mobile app logo for the coach',
    [HistoryEventType.APP_THEME_SET]: 'Set up mobile app theme for the coach',
    [HistoryEventType.WELCOME_PACK_SET]: 'Welcome pack was set up by {userName}.',
    [HistoryEventType.SLACK_CHANNEL_SET]: 'Configure Slack channel for the coach',
    [HistoryEventType.COACH_LAUNCHED]: 'Coach has been officially launched',
    [HistoryEventType.FIRST_LEAD]: 'First lead is yet to submit',
    [HistoryEventType.FIRST_SUBSCRIPTION]: 'First client is yet to subscribe',
    [HistoryEventType.SOCIAL_HANDLES_ADDED]: 'Social handles are yet to be added',
    [HistoryEventType.IS_AC_QUESTIONNAIRE_SUBMITTED]: 'The IS & AC Questionnaire is yet to be submitted',
    [HistoryEventType.CONTENT_URLS_SUBMITTED]: 'The Content URLs are yet to be submitted',
    [HistoryEventType.GOOGLE_CALENDAR_CREATED]: 'The Google Calendar is yet to be created',
    [HistoryEventType.COACH_ONBOARDING_FORM_COMPLETED]: 'The Onboarding Form is yet to be completed',
    [HistoryEventType.TRANSFORMATION_POST_SUBMITTED]: 'The Transformation Post is yet to be submitted',
    [HistoryEventType.LAUNCH_POST_SUBMITTED]: 'The Launch Post is yet to be submitted',
    [HistoryEventType.FIRST_CHAT_MESSAGE_SENT]: 'The first chat message is yet to be sent',
  },
  notSignedUp: 'Coach has not signed up yet',
  completionFailed: 'Failed to mark the item as completed',
  manualChecklist: 'Manual Checklist',
  automaticChecklist: 'Auto Captured Pending Events',
  coachTasks: 'Coach Tasks',
  camTasks: 'CAM Tasks',
  onboardingChecklistAnswers: 'Onboarding Checklist Answers',
  noPending: 'No pending items to show for the coach. It means either the coach has completed all the '
    + 'onboarding steps or the coach is not eligible for pending items.',
  modalTitle: 'Are you sure you want to mark this item as completed?',
  showAnswers: 'Show Answers',
  isAcQuestionnaire: 'IS & AC Questionnaire',
  contentURLs: 'Content URLs',
  coachFolder: 'Onboarding Form & Promotional Photos',
  openCoachFolder: 'Open Coach Folder',
  launchDateUpdated: 'Launch date updated successfully',
  launchDateUpdateFailed: 'Failed to update launch date: {error}',
};

export default texts;
